import { render, staticRenderFns } from "./TaskW2s.vue?vue&type=template&id=17a71f9c&scoped=true"
import script from "./TaskW2s.vue?vue&type=script&lang=js"
export * from "./TaskW2s.vue?vue&type=script&lang=js"
import style0 from "./TaskW2s.vue?vue&type=style&index=0&id=17a71f9c&prod&scoped=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a71f9c",
  null
  
)

export default component.exports